import { createPinia } from "pinia";

// Create pinia instance.
const pinia = createPinia();

export default pinia;
